import i18next, { t } from "i18next"
import toast from "react-hot-toast"
import { educationStages, semesters, subjects } from "./Constants"
import * as qs from "qs"
import { Collapse } from "antd"
import ParseHtml from "components/ParseHtml"
import { Fragment } from "react"
import parsePhoneNumberFromString from 'libphonenumber-js/min';
import generalCourseImage from '../assets/media/Subjects/generalCourse.png'

export const setActiveElement=(number, selector='.main_navbar_items a' , activeClassName = 'active_main_navbar_items')=>{
  const index = number - 1 
  const items = document.querySelectorAll(selector)
  if(items?.[index]){
    items.forEach((item)=>{
      item.classList.remove(activeClassName)
    })
    items[index].classList.add(activeClassName)
  }
}

export const getInitials = (str) => {
  const results = [];
  const wordArray = str?.split(" ") || [];
  wordArray.forEach((e) => {
  results.push(e[0]);
  });
  return results.join("")?.slice(0, 2);
};

export const handleSlides = (width , count = 0) => {
  let result  = 3

  if((width <= 1050 && width > 740) || count === 2) {
    result = 2
  }else if(width <= 740 || count === 1 ){
    result = 1
  }else {
    result = 3
  }
  return result
}

const CURRENCY_DEFAULTS = {
  saudi: { symbol: 'ر.س', rate: 3.75 },
  egypt: { symbol: 'ج.م', rate: 50 },
}

export const loadExchangeRates = async () => {
  try {
    const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD')
    const data = await res.json()
    localStorage.setItem('exchange_rates', JSON.stringify({
      EGP: data.rates.EGP,
      SAR: data.rates.SAR,
    }))
  } catch {
    // يستخدم الأسعار الافتراضية
  }
}

export const getCurrency = () => {
  const country = localStorage.getItem('country') || 'egypt'
  const stored = JSON.parse(localStorage.getItem('exchange_rates') || '{}')
  if (country === 'saudi') {
    return { symbol: 'ر.س', rate: stored.SAR || CURRENCY_DEFAULTS.saudi.rate }
  }
  return { symbol: 'ج.م', rate: stored.EGP || CURRENCY_DEFAULTS.egypt.rate }
}

export const convertPrice = (usdPrice) => {
  const { rate } = getCurrency()
  return roundToTwoDecimals(+usdPrice * rate)
}

export const roundToTwoDecimals = (num, cells = 2) => {
  if (+num === 0) {
      return 0
  }
  if (num) {
      return parseFloat(num).toFixed(cells)
  } else {
      return '0'.padEnd(cells + 2, '0')
  }
}

let activeToastId = null
export const Notification = (text = i18next.t("Network Error"), time = 2500, type = 'error', onClose, maxErrors = 2) => {
  const handleMessages = () => {
      if (typeof text === 'object') {
          return Object.values(text).map((message, index) => {
              if (typeof message === 'string' && index + 1 <= maxErrors) {
                  return <div style={{ width: '100%' }} key={`message_${index}`}>{message}</div>
              } else {
                  return i18next.t("Network Error")
              }
          })
      } else {
          return i18next.t(text)
      }
  }

  if (!activeToastId) {
      activeToastId = toast.custom(<div>{handleMessages()}</div>, {
          duration: time,
          type,
          position: 'top-center',
          onClose: () => {
              activeToastId = null
              if (onClose && typeof onClose === 'function') {
                  onClose()
              }
          }
      })

      setTimeout(() => {
          toast.dismiss(activeToastId)
          activeToastId = null
      }, time + 100)
  }
} 

export const blockButton = (calssName = 'submitButton_m17') => {
  const button = document.querySelector(`.${calssName}`)
  button.classList.remove('open_button_m17')
  button.classList.add('block_button_m17')
  button.disabled = true
}
export const openButton = (calssName = 'submitButton_m17') => {
  const button = document.querySelector(`.${calssName}`)
  setTimeout(() => {
    button.classList.remove('block_button_m17')
    button.classList.add('open_button_m17')
    button.disabled = false
  }, 1000);
}

export const encryptId = (id) => {
  return btoa(id);
}

export const decryptId = (id) => {
  return atob(id)
}

export const textTruncate=(text , maxLength = 10 , concatinationWord = '...')=>{
  const lang = localStorage.getItem('i18nextLng')
  const textLength = text?.length
  const result = text?.slice(0 , maxLength)
  return textLength > maxLength ? (lang === 'ar' ? result + concatinationWord : concatinationWord + result)  : result
}

export const getSubject = (country, grade, track , subject , valueKey = 'value' , labelKey = 'label') => {
  let data = []
  if (country === 'saudi' && ['s2', 's3'].includes(grade) && track) {
    data = subjects?.[country]?.[track]?.[grade]
  } else {
    data = subjects?.[country]?.[grade]
  }
  return getDefaultOption(data, subject , valueKey , labelKey)
}

export const getDefaultOption = (data = [], key , valueKey = 'value' , labelKey = 'label' , returnAll = false) => {
  const label = data?.filter(item => item?.[valueKey] === key)?.[0]
  if (returnAll) {
    return label
  }
  else {
    return label?.[labelKey]
  }
}

export const filterBuilder = (params, useQueryString = true, removeKeys = []) => {
  const result = {}
  try {
      const { filters, ...restParams } = params
      for (const key in filters) {
          if (!removeKeys?.includes(key)) {
          if (key && key.indexOf(";") !== -1) {
              key.split(";").map((_k) => {
              if (_k && _k.length) {
                  result[_k] = filters[key]
              }
              })
          } else {
          result[key] = filters[key]
          }
          }
      }
      if (useQueryString) {
          return qs.stringify({
          ...restParams,
          filter: result
          })
      }
      } catch (error) {}
      return result
  }

  export const handleCollapsedLessons = (lessons = [] , setActivePart) => {
    let result = []
    lessons?.forEach(({ title , parts , id })=> {
      result?.push(
        {
          key: id,
          label: title,
          children: (
            <Collapse
              className="custom_m17_collapse_units"
              items={handleCollapsedParts(parts)}
              onChange={ opt => {
                if(setActivePart){
                  const activePartIndex = +opt?.[0] - 1 
                  const part = activePartIndex >= 0 ? parts?.[activePartIndex] : undefined
                  setActivePart(part)
                }
              }}
              accordion
            />
          ),
        },
      )
    })
    return result
  }

  export const handleCollapsedParts = (parts = []) => {
    let result = []
    parts?.forEach(({ title , details , id})=> {
      result?.push(
        {
          key: id,
          label: title,
          children: (
            <ParseHtml htmlContent={details}/>
          ),
        },
      )
    })
    return result
  }

  export const base64ToBlobUrl = (base64Data, contentType) => {
    const byteCharacters = atob(base64Data) // فك Base64
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return URL.createObjectURL(blob) // تحويل Blob إلى URL
}

export  const handleColor = (number)=> {
  return number === 0 ? 'secondary' : (number > 0 ? 'success' : 'danger')
}

export const handleDiscount = (discount = 0, total) => {
  const price = total - discount 
  return discount ? roundToTwoDecimals(price / total * 100) : 0
}


export const Price = ({ price , discount }) => {
  const { symbol } = getCurrency()
  const hasDiscount = +discount && +discount !== +price
  return (
    <div>
      <div className={`${hasDiscount ? 'text-decoration-line-through text-secondary' : ''} `}>{convertPrice(price)} {symbol}</div>
      {hasDiscount ? <div className='fw-bold m-0'>{convertPrice(discount)} {symbol}</div> : null }
    </div>
  );
}

export const courseData = (item) =>{
  let result = {}

  if(item?.type !== 'general')
  {
    const course = item?.edu_course || item?.live_course
    const price = course?.price 
    const discount = course?.current_discount?.discount_price || price
    result ={
      title : <Fragment>
        <div>{textTruncate(getSubject(course?.country , course?.stage , course?.track , course?.subject) , 20)} - {i18next.t(getDefaultOption(educationStages , course?.stage))}</div>
        <div style={{marginTop : '2px'}}>{textTruncate(i18next.t(getDefaultOption(semesters?.[course?.country] , course?.semester)) , 20)}</div>
      </Fragment>,
      img : course?.img,
      price : <Price price={price} discount={discount}/> ,
      meta : {
        price : price ,
        afterDiscount : discount
      }
    }
  }else {
    const price = item?.general_course?.price
    const discount = item?.general_course?.current_discount?.discount_price || price
    result ={
      title: <span>{textTruncate(item?.general_course?.title , 30)}</span>,
      img : item?.general_course?.img,
      price : <Price price={price} discount={discount}/>,
      meta : {
        price : price ,
        afterDiscount : discount
      },
      category : item?.general_course?.category?.name
    }
  }
  return result
}

export const handleTotalPrice = (cart = [] , couponPercentage) =>{
  let prices = 0
  let discounts = 0
  let afterDiscounts = 0
  cart?.map((item)=> {
    const price = item?.course?.price
    const discount = item?.course?.current_discount?.discount_price || 0
    prices += +price
    discounts += +discount
  })
  afterDiscounts = prices - discounts
  const percentageDiscount = (couponPercentage * afterDiscounts / 100) || 0
  const finallPrice = afterDiscounts - percentageDiscount
  return {
    prices : convertPrice(prices) ,
    afterDiscounts : convertPrice(afterDiscounts),
    discounts : convertPrice(discounts),
    couponPercentage : convertPrice(percentageDiscount) || 0 ,
    finallPrice : convertPrice(finallPrice)
  }
}

export const roundToHalf = (num) =>  {
  return Math.round(num * 2) / 2;
}

export const checkPhoneValidation = intial => {
  if(!intial || intial?.length < 8) return false;
  const phone = intial?.startsWith('+') ? intial : `+${intial}`;
  const parsedNumber = parsePhoneNumberFromString(phone);
  const isValid = parsedNumber?.isValid();
  const country = parsedNumber?.country;
  if(country === 'EG'){ // manually because the phone number in egypt is valid in google-libphone if > 8
    return isValid && /^\+20\d{10}$/.test(phone);
  }
  return isValid 
}
export const getCourseData = (grade, country, stage, track) => {

  let data = []
  if (country === 'saudi' && ['s2', 's3'].includes(stage)) {
    data = subjects?.[country]?.[track]?.[stage]
  } else {
    data = subjects?.[country]?.[stage]
  }

  return getDefaultOption(data, grade , 'value', 'label', true)
}

export const getCourse = (course) =>{

  if(!course) return <>&#8213;</>

  if(course?.stage === 'general' || course?.type === 'general') {
    return {
      title: course?.title,
      stage: t('General Courses'),
      logo : generalCourseImage
    }
  }
  const data = getCourseData(course?.subject, course?.country, course?.stage, course?.track)
  const stage = getDefaultOption(educationStages , course?.stage )

  return {
    title: data?.label,
    stage: t(stage),
    logo : data?.logo
  }
}